import React, { useState, useEffect, useMemo } from "react";
import "./HomeSlider.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import loadimg from "../../images/loader_wish.gif";
import axios from "axios";
import { END_URL, IMG_URL } from "../../config";

function HomeSlider({ HomeBanner }) {
  const [Result, setResult] = useState("");
  const [Demension, setDemension] = useState("");
  const [TempContent, setTempContent] = useState("");
  const [TempContentBtn, setTempContentBtn] = useState("");
  const [imageLoaded, setImageLoaded] = useState(false);

  const user = localStorage.getItem("user");
  const token = localStorage.getItem("token");
  const slug = localStorage.getItem("handle_1");
  const testslug = localStorage.getItem("handle_2");
  const LocalTest = JSON.parse(localStorage.getItem(slug));

  const result_letter = useMemo(() => {
    return (
      LocalTest?.data?.map((item) => ({
        final_letter:
          item.letter === "left" ? item.leftletter : item.rightletter,
      })) || []
    );
  }, [LocalTest]);

  useEffect(() => {
    if (Array.isArray(result_letter) && result_letter.length > 0) {
      const finalResult = result_letter
        .map((item) => item.final_letter)
        .join("");
      setResult(finalResult);
    }
  }, [result_letter]);

  useEffect(() => {
    if (!user && Result) {
      FetchResultData(Result);
    }
  }, [user, Result]);

  const FetchResultData = async (finalResult) => {
    try {
      const response = await fetch(
        `${END_URL}/no-login-result/${slug}/${testslug}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ result: finalResult }),
        }
      );

      const data = await response.json();
      setDemension(data.dimension);
      setTempContent(data.final_template_content);
      setTempContentBtn(data.user_archetype_button);
    } catch (error) {
      console.error("Error sending result:", error);
    }
  };

  const [bgLoaded, setBgLoaded] = useState(false);
  
  const sliderData =  HomeBanner;

  const isLoading = !sliderData;

  useEffect(() => {
    if (sliderData?.image) {
      const img = new Image();
      img.src = `${IMG_URL}/d0/${sliderData.image}`;
      img.onload = () => setBgLoaded(true);
    }
  }, [sliderData]);

  return (
    <div
      className={`home-slider ${Demension ? "home-past-result" : ""} ${bgLoaded ? "loaded" : ""}`}
      // style={{
      //   background: `url(${IMG_URL}/d0/${sliderData?.image}) no-repeat center center`,
      //   backgroundSize: 'cover',
      // }}

      style={{
        backgroundColor: sliderData?.bg_color || "#ffffff80",
        backgroundImage: bgLoaded
          ? `url(${IMG_URL}/d0/${sliderData?.image})`
          : "none",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "cover",
        transition: "background 0.3s ease-in-out",
      }}
    >
      {!bgLoaded && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "#ffffff7c",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
            zIndex: 1,
          }}
        />
      )}

      <div className="container">
        <div className="row home-slider-row">
          <div className="col-12 col-sm-12 col-md-6 col-lg-6 header-slider-col">
            <div className="home-slider-content-div">
              {sliderData && (
                <div className="home-slider-sun-box">
                  {Demension && (
                    <div className="home-no-user">
                      <h3
                        className="asm-title-div-h3"
                        dangerouslySetInnerHTML={{ __html: TempContent }}
                      />
                      <a
                        className="home-slider-sun-box-a"
                        href={`result/${slug}/${testslug}`}
                        rel="noopener noreferrer"
                      >
                        <span className="home-slider-sun-box-a-text">
                          {/* {Demension?.name}  */} {TempContentBtn}
                        </span>
                        <span className="home-slider-sun-box-a-icon">
                          <FontAwesomeIcon icon={faArrowRight} />
                        </span>
                      </a>
                    </div>
                  )}

                  <h1 className="home-slider-sun-box-h2">
                    {isLoading ? (
                      <span className="skeleton-text skeleton-title"></span>
                    ) : (
                      <span
                        dangerouslySetInnerHTML={{ __html: sliderData?.title }}
                      ></span>
                    )}
                  </h1>

                  <p className="home-slider-sun-box-p">
                    {isLoading ? (
                      <>
                        <span className="skeleton-text skeleton-line"></span>
                        <span className="skeleton-text skeleton-line"></span>
                        <span className="skeleton-text skeleton-line short"></span>
                      </>
                    ) : (
                      sliderData?.description
                    )}
                  </p>

                  {sliderData?.buttonlink && (
                    <a
                      className="home-slider-sun-box-a"
                      href={sliderData?.buttonlink || "#"}
                      rel="noopener noreferrer"
                    >
                      <span className="home-slider-sun-box-a-text">
                        {sliderData?.buttonname}
                      </span>
                      <span className="home-slider-sun-box-a-icon">
                        <FontAwesomeIcon icon={faArrowRight} />
                      </span>

                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                    </a>
                  )}

                  <div
                    className="home-bottom-sec"
                    dangerouslySetInnerHTML={{
                      __html: sliderData?.home_button_bottom,
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeSlider;